// Module
var code = "<div class=\"print-current-perf-band\">\n    <perf-band-legend name=\"true\"><perf-band-legend>\n</div>\n";
// Exports
module.exports = code;